import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Loading } from 'adc-ui-components';

import { loadLabel } from '../../actions/label';

import ErrorModal from '../../components/ErrorModal';
import { showPage } from '../../helpers/polaris';

const showPrintDialog = () => {
  // let some time for image to render
  window.setTimeout(window.print, 100);
};

const PrintLabel = ({
  handleLoadLabel,
  match,
  loading,
  error,
  labelLink,
}) => {
  const [labelDataUrl, setLabelDataUrl] = useState(null);
  const [labelError, setLabelError] = useState(null);

  useEffect(() => {
    handleLoadLabel(match.params.id);
  }, [handleLoadLabel, match.params.id]);

  useEffect(() => {
    if (labelLink) {
      fetch(labelLink, {
        mode: 'cors',
      })
        .then(r => r.text())
        .then((text) => {
          setLabelDataUrl(`data:image/gif;base64,${text}`);
        }).catch((e) => {
          setLabelError(e);
        });
    }
  }, [labelLink]);

  if (loading) return <Loading />;

  if (error || labelError) return <ErrorModal />;
  if (labelDataUrl) {
    showPage();
    showPrintDialog();
    return (
      <img src={labelDataUrl} alt="shipping label" />
    );
  }
  return null;
};

const mapStateToProps = (
  { label: { loading, error, labelById } },
  { match: { params: { id } } },
) => ({
  loading,
  error,
  labelLink: (labelById[id] || {}).labelLink,
});

const mapDispatchToProps = dispatch => ({
  handleLoadLabel: bindActionCreators(loadLabel, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(PrintLabel);
